import { render } from "./SprintVillagear.vue?vue&type=template&id=46642294&scoped=true"
import script from "./SprintVillagear.vue?vue&type=script&lang=js"
export * from "./SprintVillagear.vue?vue&type=script&lang=js"

import "./SprintVillagear.vue?vue&type=style&index=0&id=46642294&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46642294"]])

export default __exports__